export class DataProcessorSettings {
    enqueueTransactions: boolean;
    processTransactions: boolean;
    excludedTenantIds: string;
}